import { formatTimestampDate } from '../../shared/formatTimestampDate';

export type HRDocument = {
  id: string;
  subjectType: string;
  subjectId: string;
  subjectDescriptor?: string;
  documentType: string;
  displayName: string;
  contentType: string;
  sizeBytes: number;
  sha256: string;
  scanStatus: string;
  retentionUntil?: string;
  createdAt: string;
};

export type UploadDocumentInput = {
  subjectType: 'WORKER' | 'PERSON';
  subjectId: string;
  documentType: string;
  retentionUntil?: string;
  file: File;
};

export type DocumentRow = {
  id: string;
  name: string;
  subject: string;
  subjectType: string;
  documentType: string;
  createdAt: string;
  scanStatus: string;
  source: HRDocument;
};

export function mapDocument(document: HRDocument): DocumentRow {
  return {
    id: document.id,
    name: document.displayName,
    subject: document.subjectDescriptor?.trim()
      || (document.subjectType === 'WORKER' ? '구성원 문서' : document.subjectType === 'PERSON' ? '개인 문서' : '대상 정보 없음'),
    subjectType: document.subjectType === 'WORKER' ? '구성원' : document.subjectType === 'PERSON' ? '개인' : document.subjectType,
    documentType: documentTypeLabel(document.documentType),
    createdAt: formatTimestampDate(document.createdAt),
    scanStatus: document.scanStatus,
    source: document,
  };
}

export type DocumentSubjectOption = { id: string; name: string; detail?: string };

export const documentTypeOptions = [
  { value: 'EMPLOYMENT_CONTRACT', label: '근로계약서' },
  { value: 'CONSENT', label: '동의서' },
  { value: 'IDENTITY', label: '신분 확인 서류' },
  { value: 'EDUCATION', label: '학력 증빙' },
  { value: 'CAREER', label: '경력 증빙' },
  { value: 'OTHER', label: '기타 서류' },
];

export function documentTypeLabel(value: string): string {
  if (value === 'CONTRACT') return '계약서';
  return documentTypeOptions.find((option) => option.value === value)?.label ?? value;
}
